function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "_clipPath_d1hTdz5p0TAQ7zZV6XTVecoavZqcAFGt"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 120,
  height: 120
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#_clipPath_d1hTdz5p0TAQ7zZV6XTVecoavZqcAFGt)"
}, /*#__PURE__*/React.createElement("clipPath", {
  id: "_clipPath_JP37CIsk5K6k8aXEpUkQWfEPfpAoJ01U"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 120,
  height: 120,
  transform: "matrix(1,0,0,1,0,0)",
  fill: "rgb(255,255,255)"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#_clipPath_JP37CIsk5K6k8aXEpUkQWfEPfpAoJ01U)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "_clipPath_4pmAJm933xbh6I4Tb5vNVSUoHB89L53u"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 120,
  height: 120,
  transform: "matrix(1,0,0,1,0,0)",
  fill: "rgb(255,255,255)"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#_clipPath_4pmAJm933xbh6I4Tb5vNVSUoHB89L53u)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: " M 63.343 22.318 L 63.343 35.558 L 30.037 17.777 L 63.343 0 L 63.343 13.414 C 91.459 14.812 114.702 33.399 119.22 58.106 C 123.737 82.817 108.316 106.99 82.145 116.232 C 55.973 125.47 26.092 117.284 10.311 96.553 C -5.474 75.822 -2.913 48.123 16.469 29.962 C 18.37 28.183 21.538 28.11 23.543 29.8 C 25.544 31.494 25.624 34.31 23.723 36.092 C 7.618 51.196 5.466 74.209 18.538 91.471 C 31.609 108.734 56.409 115.621 78.211 108.046 C 100.014 100.471 112.986 80.458 109.421 59.892 C 105.856 39.327 86.714 23.712 63.355 22.318 L 63.343 22.318 Z ",
  fill: "rgb(102,102,102)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 75.842 78.935 C 68.222 78.935 63.68 74.272 63.68 66.471 C 63.68 58.667 68.226 54.056 75.842 54.056 C 83.457 54.056 88 58.71 88 66.505 C 88 74.3 83.449 78.935 75.842 78.935 Z  M 75.842 57.588 C 71.769 57.588 69.436 60.824 69.436 66.471 C 69.436 72.243 71.727 75.416 75.842 75.416 C 79.957 75.416 82.224 72.237 82.224 66.471 C 82.224 60.824 79.899 57.588 75.842 57.588 Z  M 44.834 78.935 C 41.975 79.211 39.085 78.601 36.845 77.246 C 34.608 75.894 33.214 73.914 33 71.774 L 38.451 71.774 C 38.699 73.96 41.219 75.354 44.88 75.354 C 48.54 75.354 51.087 73.797 51.087 71.56 C 51.087 69.252 48.655 67.817 44.742 67.817 L 40.734 67.817 L 40.734 64.549 L 44.616 64.549 C 45.994 64.657 47.373 64.331 48.41 63.653 C 49.453 62.974 50.064 61.998 50.094 60.971 C 50.094 58.865 47.945 57.508 44.616 57.508 C 43.212 57.394 41.803 57.719 40.727 58.402 C 39.651 59.086 38.997 60.067 38.925 61.119 L 33.619 61.119 C 33.73 59.046 35.004 57.103 37.131 55.76 C 39.257 54.418 42.043 53.802 44.811 54.056 C 50.964 54.056 55.614 56.775 55.614 60.377 C 55.79 63.01 53.335 65.333 49.854 65.83 L 49.854 66.112 C 53.908 66.278 57.038 68.825 56.889 71.841 C 56.889 75.885 51.709 78.935 44.834 78.935 Z ",
  fill: "rgb(102,102,102)"
})))))))));

var SvgBackward2 = function SvgBackward2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 120 120",
    width: "40px",
    height: "40px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBackward2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/backward2.47d69056.svg";
export { ForwardRef as ReactComponent };